import axios from 'axios'

export function useRecordSgaGoal() {
    const recordSgaGoal = (type, context = {}) => {
        axios.post('/api/sga/record-goal', { type, ...context })
            .then(({ data }) => {
                if (data.sga_awarded) {
                    const award = data.sga_awarded
                    if (data.performer) { award.performer = data.performer }
                    window.dispatchEvent(new CustomEvent('show-sga-overlay', { detail: award }))
                }
            })
            .catch(() => {})
    }

    return { recordSgaGoal }
}
